import { TDeviceType } from '@cian/ui-kit/types/TDeviceType';
import { EFillApplicationStickyButtonType } from '../../containers/stickyButtons/FillApplicationButton/types';

export enum ETargetElementForAnalytics {
  CARD = 'card',
  BUTTON = 'button',
}

export type TMasterButtonType = EFillApplicationStickyButtonType.TOP | EFillApplicationStickyButtonType.BOTTOM;

export interface ITrackFunctionParams {
  event?: string;
  ec?: string;
  ea: 'newpage' | 'click' | 'show' | 'change' | 'success';
  el: string;
  deviceType: TDeviceType;
  userId: number | null;
  extra?:
    | Record<string, string | number | boolean | undefined | null>
    | IExtraForTrackEditFormValues
    | IExtraForTrackOnClickOfferButton
    | IExtraForTrackShowOffers
    | IExtraForTrackMultiOffer;
}

interface IExtraForTrackOnClickOfferButton {
  offer: IOfferForTrackOnClickButton | null;
}

interface IExtraForTrackShowOffers {
  offers: IOffersForShowOffers;
}

interface IExtraForTrackMultiOffer {
  bank: string;
  offers: IOffersForShowMultiOffers;
}
interface IExtraForTrackEditFormValues {
  userInput: Record<string, string | undefined | null | number | boolean>;
}

export interface IBaseProps {
  deviceType: TDeviceType;
  userId: number | null;
}

export interface ITrackRedirectProps extends IBaseProps {
  bank: string | null;
  type: TRedirectForAnalytics | null;
  object: TTargetElementForAnalytics | null;
}

export interface ITrackFormValuesProps extends IBaseProps {
  userInput: Record<string, string | undefined | null | number | boolean>;
}

export interface ITrackClickOnOfferButtonProps extends IBaseProps {
  offer: IOfferForTrackOnClickButton | null;
}

export interface ITrackShowOffers extends IBaseProps {
  offers: IOffersForShowOffers;
}

export interface ITrackMobileShowButtonAmountOffers extends IBaseProps {
  amount: number | null;
}

export interface ITrackShowMultiOffers extends IBaseProps {
  bank: string;
  offers: IOffersForShowMultiOffers;
}

export interface ITrackMasterButtonProps extends IBaseProps {
  type: TMasterButtonType;
}

export type IOffersForShowOffers = Record<number, IOfferForShowOffers>;
export type IOffersForShowMultiOffers = Record<number, IOfferForShowMultiOffer>;

export interface IOfferForShowOffers extends IOfferForShowMultiOffer {
  bank: string;
  isMultiOffer: boolean;
}

export interface IOfferForShowMultiOffer {
  creditAmount?: number | null;
  monthlyPayment?: number | null;
  interestRate?: number;
}

export type TRedirectForAnalytics = 'ref' | 'oshk' | TMasterButtonType;

export type TTargetElementForAnalytics = ETargetElementForAnalytics.CARD | ETargetElementForAnalytics.BUTTON;

export interface IOfferForTrackOnClickButton {
  place: number;
  bank: string;
  isMultiOffer: boolean;
  type: TRedirectForAnalytics;
}
